export {
    SuiTabsModule,
    SuiTabContent,
    SuiTabHeader,
    SuiTabset,
    Tab
} from "./index";
